import { createContext, Dispatch } from 'react';
import { initialMigrationState, MigrationFlowData } from './MigrationFlowData';
import { MigrationActions } from './actions';

export const MigrationFlowContext = createContext<{
  state: MigrationFlowData;
  dispatch: Dispatch<MigrationActions>;
}>({
  state: initialMigrationState,
  dispatch: () => null,
});
